__turbopack_context__.v({
  "form-block": "FormBlock-module-scss-module___7vQBa__form-block",
  "form-block--dawn": "FormBlock-module-scss-module___7vQBa__form-block--dawn",
  "form-block--dawn-2": "FormBlock-module-scss-module___7vQBa__form-block--dawn-2",
  "form-block--dusk": "FormBlock-module-scss-module___7vQBa__form-block--dusk",
  "form-block--light-dusk": "FormBlock-module-scss-module___7vQBa__form-block--light-dusk",
  "form-block--midnight": "FormBlock-module-scss-module___7vQBa__form-block--midnight",
  "form-block--midnight-2": "FormBlock-module-scss-module___7vQBa__form-block--midnight-2",
  "form-block--warm-red": "FormBlock-module-scss-module___7vQBa__form-block--warm-red",
  "form-block__form": "FormBlock-module-scss-module___7vQBa__form-block__form",
  "form-block__submit": "FormBlock-module-scss-module___7vQBa__form-block__submit",
  "form-block__success": "FormBlock-module-scss-module___7vQBa__form-block__success",
  "form-block__wrapper": "FormBlock-module-scss-module___7vQBa__form-block__wrapper",
});
